// extracted by extract-css-chunks-webpack-plugin
module.exports = {"checkbox":"H6-dj","label":"A04Qg","opacityLabel":"f-7zh","noOpacityLabel":"DORBQ"};